module.exports = new __parcel__URL__("feature-7.113beb51.jpg").toString();